// extracted by mini-css-extract-plugin
export default {"form":"DfTnagylMgb4N97PbLTA","submitBtn":"mlkMVnDGsxDipLh3__E_","requirements":"A_N6HiTIuEXfsdWkuhpR","bounce":"lmX__L_LF8jSjO90xSH8"};